// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1eS6K","search":"Settings_search__3qVSw","filter":"Settings_filter__3KRcL"};